import axios from 'axios'
import {
  ADMIN_REGISTER_USER_REQUEST,
  ADMIN_REGISTER_USER_SUCCESS,
  ADMIN_REGISTER_USER_FAIL,
  ADMIN_UPDATE_USER_REQUEST,
  ADMIN_UPDATE_USER_SUCCESS,
  ADMIN_UPDATE_USER_FAIL,
  ADMIN_GET_USER_REQUEST,
  ADMIN_GET_USER_SUCCESS,
  ADMIN_GET_USER_FAIL
} from '../constants/adminConstants'

import { API_URL } from '../apiUrl.js'

export const register =
  (name, email, password, isAdmin, isDisabled, cid) => async (dispatch) => {
    axios.defaults.withCredentials = true
    try {
      dispatch({
        type: ADMIN_REGISTER_USER_REQUEST
      })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.post(
        `${API_URL}/admin/register`,
        { name, email, password, isAdmin, isDisabled, cid },
        config
      )

      dispatch({
        type: ADMIN_REGISTER_USER_SUCCESS,
        payload: data
      })
    } catch (e) {
      dispatch({
        type: ADMIN_REGISTER_USER_FAIL,
        payload:
          e.response && e.response.data.message
            ? e.response.data.message
            : e.message
      })
    }
  }

export const updateUser = (user) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: ADMIN_UPDATE_USER_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/admin/update/${user._id}`,
      user,
      config
    )

    dispatch({
      type: ADMIN_UPDATE_USER_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: ADMIN_UPDATE_USER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

export const getUser = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({
      type: ADMIN_GET_USER_REQUEST
    })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/admin/user/${id}`, config)

    dispatch({
      type: ADMIN_GET_USER_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: ADMIN_GET_USER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}
